import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Cookies = () => {
  const { language, t } = useLanguage();

  const content = language === 'en' ? (
    <div className="space-y-8 text-gray-600 leading-relaxed">
      <p>Vacature.ai uses cookies and similar technologies to improve the website and analyze traffic.</p>
      <p>Cookies are small text files stored on your device when you visit a website.</p>
      
      <section>
        <h2 className="text-xl font-bold text-brand-dark mb-4">Types of Cookies We Use</h2>
        <div className="space-y-6">
          <div>
            <h3 className="font-bold text-brand-dark">Necessary Cookies</h3>
            <p>These cookies are required for the website to function properly.</p>
          </div>
          <div>
            <h3 className="font-bold text-brand-dark">Analytics Cookies</h3>
            <p>We may use analytics tools such as Google Analytics to understand how visitors interact with the website.</p>
          </div>
          <div>
            <h3 className="font-bold text-brand-dark">Functional Cookies</h3>
            <p>These cookies remember user preferences such as language selection.</p>
          </div>
        </div>
      </section>

      <section>
        <h2 className="text-xl font-bold text-brand-dark mb-4">Managing Cookies</h2>
        <p>Users can manage or disable cookies through their browser settings.</p>
        <p className="mt-4">By continuing to use vacature.ai you consent to the use of cookies as described in this policy.</p>
        <p className="mt-4">For more details about personal data processing please see the Privacy Policy.</p>
      </section>
    </div>
  ) : (
    <div className="space-y-8 text-gray-600 leading-relaxed">
      <p>Vacature.ai gebruikt cookies en vergelijkbare technologieën om de website te verbeteren en het verkeer te analyseren.</p>
      <p>Cookies zijn kleine tekstbestanden die op uw apparaat worden opgeslagen wanneer u een website bezoekt.</p>
      
      <section>
        <h2 className="text-xl font-bold text-brand-dark mb-4">Soorten cookies die we gebruiken</h2>
        <div className="space-y-6">
          <div>
            <h3 className="font-bold text-brand-dark">Noodzakelijke cookies</h3>
            <p>Deze cookies zijn nodig om de website goed te laten functioneren.</p>
          </div>
          <div>
            <h3 className="font-bold text-brand-dark">Analytische cookies</h3>
            <p>We kunnen analytische tools zoals Google Analytics gebruiken om te begrijpen hoe bezoekers met de website omgaan.</p>
          </div>
          <div>
            <h3 className="font-bold text-brand-dark">Functionele cookies</h3>
            <p>Deze cookies onthouden gebruikersvoorkeuren zoals taalselectie.</p>
          </div>
        </div>
      </section>

      <section>
        <h2 className="text-xl font-bold text-brand-dark mb-4">Cookies beheren</h2>
        <p>Gebruikers kunnen cookies beheren of uitschakelen via hun browserinstellingen.</p>
        <p className="mt-4">Door vacature.ai te blijven gebruiken, stemt u in met het gebruik van cookies zoals beschreven in dit beleid.</p>
        <p className="mt-4">Voor meer details over de verwerking van persoonsgegevens verwijzen wij u naar het Privacybeleid.</p>
      </section>
    </div>
  );

  return (
    <div className="min-h-screen py-24 lg:py-32 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-5xl font-black text-brand-dark mb-16 italic uppercase tracking-tighter">
          {t.legal.cookieTitle}
        </h1>
        <div className="bg-gray-50/50 p-12 lg:p-16 rounded-[3rem] border border-gray-100 shadow-sm">
          {content}
        </div>
      </div>
    </div>
  );
};

export default Cookies;